import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import {
  diagramSelector,
  devicesSelector,
  factoriesSelector,
  nextDiagramIdSelector,
  isAdminSelector,
} from '../selectors';
import {
  createDiagramItem,
  updateDiagramItem,
  deleteDiagramItem,
  onFetchDiagram,
} from '../actions/entry';
import Diagram from '../components/Diagram';

const mapStateToProps = (state) => {
  const diagrams = diagramSelector(state);
  const devices = devicesSelector(state);
  const factories = factoriesSelector(state);
  const devicesDiagram = [];
  devices.forEach((device) => {
    const diagram = diagrams.find((di) => di.diagram?.data?.id === device.id);
    if (diagram === undefined) {
      devicesDiagram.push({
        ...device,
      });
    }
  });
  const isAdmin = isAdminSelector(state);

  const nextId = nextDiagramIdSelector(state);

  return {
    factories,
    nextId,
    items: diagrams,
    devices: devicesDiagram,
    isEditable: isAdmin,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      onCreateDeviceDiagram: createDiagramItem,
      onUpdateDiagram: (data) => updateDiagramItem(data.id, data),
      onDeleteDiagram: (id) => deleteDiagramItem(id),
      onFetchDiagram,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(Diagram);
